import { FunnelSimpleIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Sort = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <FunnelSimpleIcon fill={fill} {...rest} size={Sizes[size]} />;
};

Sort.displayName = 'Sort';
